export interface LanguageSelectorProps {
  isActive: boolean;
}

export enum LanguageAbbreviations {
  en = 'Eng.',
  es = 'Esp.',
  ca = 'Cat.'
}
